/*
  Black Friday Sale "added to bag" pop-up (Nov 2, Jonathan picked mockup A, then "P1"). After the FIRST pant or
  short goes into the bag from a product page, a centred pop-up offers three 2nd pants at 50% off in the shopper's
  size instead of the drawer opening; "Add" is the only button, "View more" (men's / women's best sellers) and
  "Stay on page" are small links kept well away from it. Once per visit (sessionStorage), only while the promo is
  live. A card's Add goes through /cart/add.js, which Shopify reports as a standard add to cart (Meta pixel too).
  The cards come from the drawer's own "Add a 2nd pant" panel (snippets/kw-pair-up.liquid) inside the
  add-to-cart response's cart-drawer section, so the pop-up and the bag always show the same suggestions and
  prices. product-form.js publishes cartUpdate before it re-renders the drawer, so at that moment the drawer
  still shows the bag BEFORE this add: data-kw-ebf-n there must be 0 (no pant yet). The drawer's open() is
  skipped once (renderContents would open it); "View bag" opens it.
*/
/*
  "You viewed" (Nov 2): every product page this shopper opens goes to the front of localStorage kwViewed (8 max). The list
  is written to the hidden cart attribute _kw_viewed (only when it changed) so snippets/kw-pair-up.liquid can put
  those pants first in the bag's strip and in this pop-up. Only while the promo is live.
*/
(function () {
  var m = /\/products\/([^/?#]+)/.exec(location.pathname);
  if (!m || !document.documentElement.classList.contains('kw-bmsm-live')) return;
  var h = decodeURIComponent(m[1]);
  var list = [];
  try { list = JSON.parse(localStorage.getItem('kwViewed') || '[]'); } catch (e) {}
  if (!Array.isArray(list)) list = [];
  list = [h].concat(list.filter(function (x) { return x !== h; })).slice(0, 8);
  try { localStorage.setItem('kwViewed', JSON.stringify(list)); } catch (e) {}
  var val = list.join(',');
  try { if (sessionStorage.getItem('kwViewedSent') === val) return; } catch (e) {}
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _kw_viewed: val } }) })
    .then(function (r) { if (r.ok) try { sessionStorage.setItem('kwViewedSent', val); } catch (e) {} })
    .catch(function () {});
})();

(function () {
  if (!window.kwPair || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  var hold = false;
  var box = null;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  customElements.whenDefined('cart-drawer').then(function () {
    var P = customElements.get('cart-drawer').prototype;
    var open = P.open;
    P.open = function () {
      if (hold) { hold = false; return; }
      return open.apply(this, arguments);
    };
  });

  function live() { return document.documentElement.classList.contains('kw-bmsm-live'); }
  function seen() { try { return sessionStorage.getItem('kwPairSeen') === '1'; } catch (e) { return false; } }
  function mark() { try { sessionStorage.setItem('kwPairSeen', '1'); } catch (e) {} }
  function pantsBefore() {
    var c = document.querySelector('[data-kw-ebf-n]');
    return c ? parseInt(c.getAttribute('data-kw-ebf-n'), 10) || 0 : 0;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  function close() {
    if (!box) return;
    box.remove();
    box = null;
    document.body.classList.remove('kw-pair-lock');
    document.removeEventListener('keydown', onKey);
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function drawer() { return typeof getActiveCartDrawer === 'function' ? getActiveCartDrawer() : document.querySelector('cart-drawer'); }

  function add(btn) {
    btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.getAttribute('data-variant-id')), quantity: 1 }], sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status === 422 || res.j.description) { btn.disabled = false; btn.textContent = 'Sold out'; return; }
        close();
        var d = drawer();
        if (d && d.renderContents) d.renderContents(res.j);
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kw-pair', cartData: res.j });
      })
      .catch(function () { btn.disabled = false; });
  }

  function show(panel) {
    var size = panel.getAttribute('data-size') || '';
    var tight = size.replace(/\s+/g, '');
    box = document.createElement('div');
    box.className = 'kw-pair-pop';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-labelledby', 'kwPairPopH');
    box.innerHTML =
      '<div class="kw-pair-pop__dim" data-kw-close></div>' +
      '<div class="kw-pair-pop__box">' +
      '<button type="button" class="kw-pair-pop__x" data-kw-close aria-label="Close">&times;</button>' +
      '<div class="kw-pair-pop__added">' +
      (panel.getAttribute('data-img') ? '<img src="' + esc(panel.getAttribute('data-img')) + '" alt="" width="52" height="65">' : '') +
      '<div><p class="kw-pair-pop__ok"><svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12.5l5 5L20 6.5" fill="none" stroke="currentColor" stroke-width="3"/></svg>Added to bag</p>' +
      '<p class="kw-pair-pop__t">' + esc(panel.getAttribute('data-title')) + '</p>' +
      '<p class="kw-pair-pop__s">' + esc(size) + ' · ' + esc(panel.getAttribute('data-price')) + '</p>' +
      (panel.getAttribute('data-hat') === '1' ? '<p class="kw-pair-pop__hat">+ <b>FREE</b> mystery hat added</p>' : '') +
      '</div></div>' +
      '<p class="kw-pair-pop__h" id="kwPairPopH">Get your 2nd pant <em>50% off</em></p>' +
      '<p class="kw-pair-pop__sub">In stock in your size, ' + esc(size) + '.</p>' +
      '<div class="kw-pair-pop__cards"></div>' +
      '<p class="kw-pair-pop__fine">' + esc(panel.getAttribute('data-fine')) + '</p>' +
      '<div class="kw-pair-pop__links">' +
      '<a class="kw-pair-pop__link" href="' + esc(panel.getAttribute('data-more') || (root + 'collections/mens-best-sellers')) + '">View more</a>' +
      '<button type="button" class="kw-pair-pop__link" data-kw-close>Stay on page</button>' +
      '</div>' +
      '</div>';
    var cards = box.querySelector('.kw-pair-pop__cards');
    Array.prototype.slice.call(panel.querySelectorAll('.kw-pair__card'), 0, 3).forEach(function (c) {
      var n = document.importNode(c, true);
      var b = n.querySelector('.kw-pair__add');
      if (b) {
        b.classList.remove('cart-drawer-b__rec-add');
        b.textContent = 'Add ' + tight;
        b.addEventListener('click', function () { add(b); });
      }
      cards.appendChild(n);
    });
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-kw-close]')) close();
    });
    document.body.appendChild(box);
    document.body.classList.add('kw-pair-lock');
    document.addEventListener('keydown', onKey);
    var panelBox = box.querySelector('.kw-pair-pop__box');
    panelBox.setAttribute('tabindex', '-1');
    panelBox.focus({ preventScroll: true });
  }

  subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
    if (!e || e.source !== 'product-form' || !live() || seen()) return;
    if (!/\/products\//.test(location.pathname)) return;
    var d = e.cartData;
    if (!d || !d.sections || !d.sections['cart-drawer']) return;
    if (pantsBefore() !== 0) return;
    var doc = new DOMParser().parseFromString(d.sections['cart-drawer'], 'text/html');
    var panel = doc.querySelector('[data-kw-pair]');
    if (!panel || !panel.querySelector('.kw-pair__card')) return;
    hold = true;
    setTimeout(function () { hold = false; }, 1500);
    mark();
    show(panel);
  });
})();
